import { RolesEnum } from "./rolesEnum";

const nonSiteUsers = [RolesEnum.SuperAdmin, RolesEnum.Admin, RolesEnum.LogisticsTeam];

const CheckPermissions = (currentRole: RolesEnum, permittedRoles: RolesEnum[]) : boolean => permittedRoles.includes(currentRole);
const IsNonSiteUser = (currentRole : RolesEnum) => CheckPermissions(currentRole, nonSiteUsers);
export { CheckPermissions, IsNonSiteUser };
